// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './languages/i18n';
Vue.config.productionTip = false;

axios.interceptors.request.use(function (config) {
  // config.url = 'http://ccall:8888/api' + config.url;
  config.url = 'https://edit.ccall.vn/api' + config.url;
  return config;
});
Vue.use(VueAxios, axios);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
});




// WEBPACK FOOTER //
// ./src/main.js